import { Formatter, Spinner } from 'shared'
import { SmartButtonStub, SmartButtonLink } from 'ui/smart-buttons'
import { ParkApi, SmartButtonApi, Model, UserRequestApi } from 'api'
import ParkReservationSlots from './ParkReservationSlots'
import ParkReservationCalendar from './ParkReservationCalendar'
import ParkReservationDetails from './ParkReservationDetails'
import ParkServiceSelector from './ParkServiceSelector'

export default class ParkReservationBlock extends Component {
  state = { date: null, time: null, timeSlots: null, workflowComplete: false, reservationbuttonShown: false, showCalendar: false, pendingSlot: null }

  async componentDidMount() {
    const selectedDate = this.getSelectedDateFromURL();
    
    this.setState({ date: selectedDate, time: null, timeSlots: null, serviceId: null })
    
    if (selectedDate) {
      this.loadedDate = selectedDate
      this.setState({ timeSlots: await ParkApi.loadTimeSlotsForDate(this.props.park, selectedDate, null) })
    }

    this.loadTimeslots()
    this.componentDidUpdate({})
    this.loadReservationButtonStatus(this.props.park);
  }

  async componentDidUpdate(prevProps) {
    const selectedDate = this.getSelectedDateFromURL();

    let prevSubroute = prevProps.subroute
    let currSubroute = this.props.subroute
    if (prevSubroute == currSubroute)
      return

    let [ prevServiceId, prevDateStr, prevTime ] = Model.extractSubrouteArgs(prevSubroute)
    let [ currServiceId, currDateStr, currTime ] = Model.extractSubrouteArgs(currSubroute)
    let prevDate = prevDateStr && moment(prevDateStr)
    let currDate = selectedDate ? moment(selectedDate) : (currDateStr && moment(currDateStr))

    if (currServiceId == 'NA')
      currServiceId = null
    this.setState({ date: currDate, time: currTime, timeSlots: null, serviceId: currServiceId })
    if (currDate && (this.loadedDate != currDate || this.loadedServiceId != currServiceId)) {
      this.loadedDate = currDate
      this.loadedServiceId = currServiceId
      this.setState({ timeSlots: await ParkApi.loadTimeSlotsForDate(this.props.park, currDate, currServiceId) })
    }
    if (prevProps.park !== this.props.park) {
      this.loadReservationButtonStatus(this.props.park);
    }
  }

  getSelectedDateFromURL() {
    const urlParams = new URLSearchParams(window.location.href.split('?')[1] || '');
    const selectedDateStr = urlParams.get('start_date') || '';
    return selectedDateStr ? moment(selectedDateStr) : null;
  }

  render() {
    let { park, base, subroute, reloadSmartButtons } = this.props
    let { date, time, timeSlots, serviceId } = this.state
    let { showCalendar } = this.state
    let { reservationbuttonShown } = this.state
    let service = park.getService(serviceId)

    this.loadWorflowStatus(park)

    let hhmm, slot
    if (time) {
      hhmm = Formatter.militaryToHHMM(time)
      slot = timeSlots && timeSlots.find(ts => ts.time == hhmm)
    }
    return (
      <div className="park-reservation-block">
      {
        reservationbuttonShown ?
          showCalendar ?
            time ?
              slot && <ParkReservationDetails {...{park, base, subroute, service, serviceId, date, time, slot}} reserve={this.reserveSlot} />
              :
              park.usesSimpleReservation || service ?
                <>
                  <ParkReservationCalendar {...{ park, base, date, service, serviceId }} />
                  <ParkReservationSlots {...{ park, base, subroute, service, serviceId, date, timeSlots }} reserve={this.reserveSlot} cancel={this.cancelSlot} />
                </>
              :
                <ParkServiceSelector {...{park, base, date}} />
          :
            <div style={{ textAlign: 'center' }}>
              <button className="smart-button btn" onClick={() => this.setState({ showCalendar: true })}><span className="smart-button-text">Reserve {park.name}</span></button>
            </div>
        :
        <p></p>
      }
      </div>
    )
  }

  reserveSlot = async (timeSlot, options = {}) => {
    let { park } = this.props
    let { workflowComplete } = this.state
    if (park.workflow_id && !workflowComplete) {
      this.setState({ pendingSlot: { timeSlot, options } })
      App.state.setObjectSilent({ pendingPlaceReservation: { parkId: park.id, timeSlot, options } })
      await this.triggerWorkflow()
      return
    }
    await this.performReserve(timeSlot, options)
  }

  triggerWorkflow = async () => {
    let { park } = this.props
    let newRequest = await UserRequestApi.create({ id: park.workflow_id })
    if (newRequest) {
      UserRequestApi.addToCollection('index', newRequest)
      App.state.setObject({ 'chat:selectedUserRequestId': newRequest.uid, 'chat:smartButton': undefined })
      App.openChat()
    }
  }

  performReserve = async (timeSlot, { tickets, serviceId, success } = {}) => {
    let { park, reloadSmartButtons } = this.props
    let timeSlots = await ParkApi.reserveTimeSlot(park, timeSlot, tickets, serviceId)
    if (timeSlots) {
      this.setState({ timeSlots })
      if (park.workflow_id) this.setState({ workflowComplete: false })
    }
    reloadSmartButtons()
    EventApi.reset('mineGrouped')
    success && success()
  }

  cancelSlot = async (timeSlot) => {
    let { park, reloadSmartButtons } = this.props
    let { date, serviceId } = this.state
    let timeSlots = await ParkApi.cancelTimeSlot(park, timeSlot)
    reloadSmartButtons()
    EventApi.reset('mineGrouped')
    this.setState({ timeSlots: await ParkApi.loadTimeSlotsForDate(park, date, serviceId) })
  }

  loadTimeslots() {
    if (this.props.park.fully_reserved_dates == undefined)
      ParkApi.show(this.props.park.id)
  }

  loadWorflowStatus = async (park) => {
    if (!this.state.workflowComplete) {
      let workflowStatus = await ParkApi.getWorkflowStatus(park)
      if (workflowStatus) {
        let pendingSlot = this.state.pendingSlot
        if (!pendingSlot) {
          const globalPending = App.state.getObject('pendingPlaceReservation')
          if (globalPending && globalPending.parkId === park.id) {
            pendingSlot = { timeSlot: globalPending.timeSlot, options: globalPending.options }
          }
        }
        App.state.deleteObjectSilent('pendingPlaceReservation')
        this.setState({ workflowComplete: true, pendingSlot: null })
        if (pendingSlot) {
          await this.performReserve(pendingSlot.timeSlot, pendingSlot.options)
        }
      }
    }
  }
  loadReservationButtonStatus = async (park) => {
    if (!this.state.reservationbuttonShown) {
      let reservationbuttonStatus = await ParkApi.getRervationButtonStatus(park)
      this.setState({ reservationbuttonShown: reservationbuttonStatus })
    }
  }
}
